import { defaultFont } from "assets/jss/material-dashboard-pro-react.jsx";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

export const createProjectsStyle = {
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    color: "#3C4858",
    fontSize: "18px"
  },
  cardHeader: {
    zIndex: "3"
  },
  cardSubtitle: {
    ...defaultFont,
    color: "#999999",
    fontSize: "14px",
    margin: "0 0 10px"
  },
  center: {
    //textAlign: "center"
  },
  right: {
    textAlign: "right"
  },
  left: {
    textAlign: "left"
  },
  marginRight: {
    marginRight: "5px"
  },
  modalSectionTitle: {
    marginTop: "30px"
  },
  ...modalStyle
};
export const projectsStyle = {
  tooltip:{
    fontSize:"12px"
  },
  root:{
    flexGrow: 1
  },
  card:{
    padding: "10 10 10 10"
  },
  labelTitle: {
    fontSize: "1.1em",
    fontWeight: "900"
  },
  label: {
    fontSize: "90%",
    fontWeight: "400",
    lineHeight: "1",
    color: "#777"
  }
};


// WEBPACK FOOTER //
// ./src/views/projects/style.js